import Timeline from "./Timeline";

const SummarySection = (props) => {


  return (
    <div
    className="summary-section flex-vertical"
      style={{
        width: props.width,
        background: "#ffffff",
        height: props.height,
        position:"relative"
      }}
    >
      
      <Timeline
        keyEvents={props.keyEvents}
        height={props.height*0.94}
        width={props.width}
        setPositionHandler={props.setPositionHandler}
        resetButtonDisplay={props.resetButtonDisplay}
        resetPosition={props.resetPosition}
      />
    </div>
  );
};

export default SummarySection;
